﻿function isUpper(c: string) {
	return c >= "A" && c <= "Z";
}

function isLower(c: string) {
	return c >= "a" && c <= "z";
}

function isDigit(c: string) {
	return c >= "0" && c <= "9";
}

function isLetter(c: string) {
	return isUpper(c) || isLower(c);
}

function isWord(c: string) {
	return isLetter(c) || isDigit(c);
}

function isSpace(c: string) {
	return c === " ";
}

function isOther(c: string) {
	return !isLetter(c) && !isDigit(c) && !isSpace(c);
}

function findTruncationSplit(value: string): number {
	for (let i = value.length - 1; i >= 1; i--) {
		const prev = value[i - 1];
		const curr = value[i];

		if (isSpace(prev) && !isSpace(curr)) return i;
		if (isUpper(curr) && (isLower(prev) || (isUpper(prev) && isLower(value[i + 1] ?? "")))) return i;
		// A non-character delimiter starts the tail only when it introduces a word
		// (e.g. the "/" in "/recurrences"), so a preceding closer like "}" stays with
		// the previous segment and a lone trailing "}" never becomes the whole tail.
		if (isOther(curr) && isWord(value[i + 1] ?? "")) return i;
	}

	return value.length > 5 ? value.length - 5 : value.length;
}

export function middleTruncate(value: string): [string, string | undefined] {
	const splitIndex = findTruncationSplit(value);
	return [value.slice(0, splitIndex), value.slice(splitIndex)]
}
